import styled from '@emotion/styled';
import React, { useState } from 'react';

import { v4 } from 'uuid';
import { typography } from '../../../styles/typography';
import type { BaseInputProps, InputSize, InputVariant } from '../Input';
import { inputCss, InputHost } from '../Input';
import { Label as InputLabel, ErrorLabel } from '../Label';

export interface InputProps
  extends React.DetailedHTMLProps<
      React.TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    >,
    BaseInputProps {}

const TextArea = styled.textarea<{
  inputSize?: InputSize;
  hasUnderline?: boolean;
  isValid: boolean;
  variant?: InputVariant;
  center?: boolean;
  setHeight?: string;
}>`
  ${inputCss};
  padding: 20px 20px 12px 15px;
  ${(props) =>
    props.inputSize === 'small'
      ? typography.numbers(props)
      : props.inputSize === 'big'
      ? typography.input(props)
      : typography.input2(props)};

  resize: none;
  outline: none;

  ::placeholder {
    color: ${(props) => props.theme.shades.primary2};
  }
  ${(props) => (props.setHeight ? `height:${props.setHeight}` : '')}
`;

export function TextInput({
  label,
  inputSize,
  id,
  isValid,
  errorMessage,
  placeholder,
  setHeight,
  variant,
  ...rest
}: InputProps & { setHeight?: string }) {
  const [uuid] = useState(v4());
  return (
    <InputHost>
      {label && (
        <InputLabel size={inputSize} htmlFor={id ?? uuid}>
          {label}
        </InputLabel>
      )}
      <TextArea
        id={id ?? uuid}
        isValid={isValid !== false}
        variant={variant}
        inputSize={inputSize}
        setHeight={setHeight}
        placeholder={placeholder}
        {...rest}
      ></TextArea>
      {isValid === false && errorMessage && (
        <ErrorLabel size={inputSize}>{errorMessage}</ErrorLabel>
      )}
    </InputHost>
  );
}
